import { MediaMatcher } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatTabNav } from '@angular/material/tabs';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { fadeAnimation } from '../../animations/fade.animation';
import { ThemeService } from '../../services/theme/theme.service';

@Component({
  selector: 'greco-menu-layout',
  templateUrl: './menu-layout.component.html',
  styleUrls: ['./menu-layout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: [fadeAnimation(0.25)]
})
export class MenuLayoutComponent implements OnDestroy, OnInit {
  @ViewChild(MatTabNav) nav: MatTabNav;

  @Input() options: { logo?: string; logoDark?: string };
  public links$ = new BehaviorSubject<{ url: string; name: string }[]>([]);
  @Input() set links(value: { url: string; name: string }[]) {
    this.links$.next(value);
  }
  public activeLink = null;

  private onDestroy$ = new Subject<void>();

  public mobileQuery: MediaQueryList;
  public fillerContent = Array.from(
    { length: 50 },
    () =>
      `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
       labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
       laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
       voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
       cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.`
  );

  private _mobileQueryListener: () => void;

  constructor(private changeDetectorRef: ChangeDetectorRef, private media: MediaMatcher, private router: Router, public themeSvc: ThemeService, private location: Location) {
    combineLatest([
      this.router.events.pipe(
        takeUntil(this.onDestroy$),
        filter(e => e instanceof NavigationEnd),
        map(e => e as NavigationEnd)
      ),
      this.links$
    ]).subscribe(([{ url }, links]) => {
      let name = links?.find(l => l?.url === url)?.name || url.slice(1)?.charAt(0)?.toUpperCase() + url?.slice(2);
      name = name.split('?')[0] || name;
      this.activeLink = { url: url.split('?')[0], name };
    });
  }

  ngOnInit() {
    this.mobileQuery = this.media.matchMedia('(max-width: 599px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    // tslint:disable-next-line: deprecation
    this.mobileQuery?.addListener?.(this._mobileQueryListener.bind(this));
  }

  ngOnDestroy(): void {
    // tslint:disable-next-line: deprecation
    this.mobileQuery?.removeListener?.(this._mobileQueryListener.bind(this));
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
